import { Col, message, Spin, Transfer } from 'antd'
import { TransferDirection } from 'antd/lib/transfer'
import { AxiosResponse } from 'axios'
import React, { useEffect, useState } from 'react'
import ViewPage from '../../../../Components/ViewPage'
import { tryError } from '../../../../services/Afins'
import {
  delTipoLiderEquipe,
  getTipoLiderEquipe,
  postTipoLiderEquipe,
  TypesTipoLiderEquipe,
} from '../../../../services/consultoriaAgricola/tipoLiderEquipe'
import { EquipeItens, getEquipe, TypesEquipe } from '../../../../services/Equipe'

import { Container } from './styles'
import { useLogic } from '../../../../context/useLogic'

const UserLiderEquipe: React.FC = () => {
  const { responsive } = useLogic()

  const [_visibleDrawer, setVisibleDrawer] = useState(false)
  const [dataEquipe, setDataEquipe] = useState<EquipeItens[]>([])
  const [dataLiderEquipe, setDataLiderEquipe] = useState<string[]>([])
  const [removeLiderEquipe, setRemoveLiderEquipe] = useState([])
  const [loading, setLoading] = useState(false)

  const listEquipe = async () => {
    message.loading('Carregando...', 99999)
    const resp: AxiosResponse<TypesEquipe> = await getEquipe({
      pagination: -1,
      permitirLiderEquipe: true,
      embed: 'usuario,tipo_lider_equipe',
    })

    setDataEquipe(resp.data.itens)
    message.destroy()
  }

  const listLiderEquipe = async () => {
    const resp: AxiosResponse<TypesTipoLiderEquipe> = await getTipoLiderEquipe({})

    const cods = resp.data.itens.map((item) => String(item.cod_usuario))

    setDataLiderEquipe(cods)
  }

  const handleClickNew = () => {
    setVisibleDrawer(true)
  }

  const handleChangeMoveTransfer = async (
    targetKeys: string[],
    direction: TransferDirection,
    moveKeys: string[]
  ) => {
    try {
      setLoading(true)
      if (direction === 'right') {
        const keys = [...removeLiderEquipe, ...moveKeys]

        const resp = await postTipoLiderEquipe({ usuarios: moveKeys })
        if (resp.data.itens?.length > 0) {
          setRemoveLiderEquipe(keys)
          setDataLiderEquipe(targetKeys)
        }
        setLoading(false)
      } else {
        for (let i = 0; i < moveKeys.length; i += 1) {
          const cod = moveKeys[i]
          await delTipoLiderEquipe(cod)
        }
        setRemoveLiderEquipe(removeLiderEquipe.filter((item) => item !== moveKeys[0]))
        setDataLiderEquipe(targetKeys)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)

      tryError(error)
    }
  }

  const filterOption = (inputValue: string, option: EquipeItens) =>
    option.usuario_nome.toLowerCase().indexOf(inputValue.toLowerCase()) > -1

  useEffect(() => {
    listEquipe()
    listLiderEquipe()
  }, [])

  return (
    <Container>
      <ViewPage
        rotina={78}
        newHide
        title='Usuário Líder'
        btnClick={() => handleClickNew()}
        content={null}
      >
        <Col span={24}>
          <Transfer
            className={responsive && 'transfer-responsive'}
            showSearch
            filterOption={filterOption}
            disabled={loading}
            rowKey={(e) => String(e.usuario[0].cod)}
            selectAllLabels={[<b>Usuário</b>, <b>Usuário líder</b>]}
            targetKeys={dataLiderEquipe}
            dataSource={dataEquipe}
            render={(record) => <> {record.usuario_nome}</>}
            listStyle={{ width: '100%', height: 'calc(100vh - 230px)' }}
            onChange={handleChangeMoveTransfer}
          />
        </Col>
      </ViewPage>
    </Container>
  )
}

export default UserLiderEquipe
